"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crop = void 0;
exports.crop = {
    path: "M5.83331 0.833328V14.1667H19.1666V15.8333H15.8333V19.1667H14.1666V15.8333H5.83331C4.91665 15.8333 4.16665 15.0833 4.16665 14.1667V5.83333H0.833313V4.16666H4.16665V0.833328H5.83331ZM15.8333 12.5H14.1666V5.83333H7.49998V4.16666H14.1666C15.0833 4.16666 15.8333 4.91666 15.8333 5.83333V12.5Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
